module.exports = __webpack_public_path__ + "img/qrcode.e6869d15.png";